interface OwnershipSummaryBarProps {
  totalPercentage: number;
}

export const OwnershipSummaryBar: React.FC<OwnershipSummaryBarProps> = ({ totalPercentage }) => {
  const total = Number(totalPercentage) || 0;
  const capped = Math.min(total, 100);
  const isOver = total > 100;
  const isComplete = total === 100;

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-gray-700">Participación accionaria total</span>
        <span
          className={`text-sm font-bold ${
            isOver ? 'text-red-600' : isComplete ? 'text-green-600' : 'text-gray-800'
          }`}
        >
          {total.toFixed(2)}%
        </span>
      </div>
      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${
            isOver ? 'bg-red-500' : isComplete ? 'bg-green-500' : 'bg-blue-500'
          }`}
          style={{ width: `${capped}%` }}
        />
      </div>
      {isOver && (
        <p className="text-xs text-red-600 mt-1">
          La suma de participaciones supera el 100%. Ajusta los porcentajes.
        </p>
      )}
      {!isComplete && !isOver && (
        <p className="text-xs text-gray-500 mt-1">
          Faltan {(100 - total).toFixed(2)}% por asignar.
        </p>
      )}
    </div>
  );
};
